import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
 
const PaginationImpl = props => {

  //Set initial state
  const [totalRecords, handletotalRecords] = useState(0)
  const [activePage, handleactivePage] = useState(1)
  const [limit, handlelimit] = useState(10)
  const [skip, handleskip] = useState(0)


   useEffect(()=>{
    handletotalRecords(props.totalRecords);
    let limit = props.limit ? props.limit : 10;
    handlelimit(limit);
  },[])

  useEffect(()=>{
    handletotalRecords(props.totalRecords);
    let limit = props.limit ? props.limit : 10;
    handlelimit(limit);
  },[props.totalRecords])
 
  //Handle Page change
 const  handlePageChange= (page)=> {
    
    let skip= limit * (page-1);
    handleactivePage(page);
    handleskip(skip)
    props.getAllData(skip);
  }
 
  //Return the pagination view
    return (
      <div className="pagination-wrapper">
        <div className="dataTables_paginate paging_full_numbers" id="advertiser-details_paginate">
         
          <Pagination
      prevPageText='Prev'
      nextPageText='Next'
      firstPageText='First'
      lastPageText='Last'
      activePage={activePage}
      itemsCountPerPage={limit}
      totalItemsCount={totalRecords}
      onChange={handlePageChange}
    />
          
        </div>
      </div>
    );
  }


export default PaginationImpl;


// WEBPACK FOOTER //
// ./web/components/admin/common/Pagination.js